import { V1YesNo } from '@ennismore/ows-api-client';

export const yesNoToBool = (yesNo: V1YesNo) => yesNo === V1YesNo.Yes;
